export const FONT_STYLE_OPTS = [
    { id: "normal", name: "Normal", value: "normal" },
    { id: "italic", name: "Italic", value: "italic" },
    { id: "oblique", name: "Oblique", value: "oblique" }
];

export const FONT_WEIGHT_OPTS = [
    { id: "lighter", name: "Light", value: "lighter" },
    { id: "normal", name: "Normal", value: "normal" },
    { id: "bold", name: "Bold", value: "bold" },
    { id: "bolder", name: "Extra Bold", value: "bolder" }
];

export const FONT_FAMILY_OPTS = [
    { id: "sans-serif", name: "Sans-Serif", value: "sans-serif" },
    { id: "serif", name: "Serif", value: "serif" },
    { id: "monospace", name: "Monospace", value: "monospace" },
];


// WEBPACK FOOTER //
// ./src/json/font_style_options.js